import { useParams } from 'react-router';

function useRoomToken() {
  const { roomToken } = useParams();

  return roomToken || '';
}

export default useRoomToken;
